import { AxiosResponse } from 'axios'
import { RequestCDU, RequestREAD } from 'services/Instances'

export const EffectiveParamsServices = () => {
  const path = 'ParametrizacaoEfetivo'

  const create = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const patch = async (requestObj: IEffectiveParams): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`, requestObj)

  //const get = async (id: number): Promise<AxiosResponse<IEffectiveParams>> =>
  //await RequestREAD.get(`${path}/${id}`)

  const get = async (): Promise<AxiosResponse<IEffectiveParams>> =>
    await RequestREAD.get(`${path}`)

  return { create, get, patch }
}

export interface IEffectiveParams {
  idParametrizacaoEfetivo?: number
  flValorHeSalarioBasePorColaborador: boolean
  dsInicioFechamentoFornecedorContraparte: string
  dsFimFechamentoFornecedorContraparte: string
  dsInicioFechamentoAnalista: string
  dsFimFechamentoAnalista: string
  vlJustVariacaoMinEfetivo: number
  vlJustVariacaoMaxEfetivo: number
  vlJustVariacaoNumHomemMin: number
  vlJustVariacaoNumHomemMax: number
  vlVariacaoHorasExtras: number
}
